import { Create, Edit, List, View } from "../Components/index.js";

export default [
    { path: "/voucher/store/payment", component: List, name: "voucher.store.payment" },
    { path: "/voucher/store/payment/create", component: Create, name: "voucher.store.payment.create" },
    { path: "/voucher/store/payment/:id/edit", component: Edit, name: "voucher.store.payment.edit" },
    { path: "/voucher/store/payment/:id/view", component: View, name: "voucher.store.payment.view" }
];
